import { Navigate } from '@sorare/routing';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { ApiKeysManagement } from '@sorare/core/src/components/settings/ApiKeysManagement';
import { OAuthApplicationsManagement } from '@sorare/core/src/components/settings/OAuthApplicationsManagement';
import {
  SettingsPage,
  TITLES,
} from '@sorare/core/src/components/settings/pages';
import { SETTINGS_ACCOUNT } from '@sorare/core/src/constants/__generated__/routes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import { SettingsWrapper } from '#src/components/settings/SettingsWrapper/index.tsx';

export const Developer = () => {
  const {
    flags: { useSelfServiceApi = false },
  } = useFeatureFlags();

  if (!useSelfServiceApi) {
    return <Navigate replace to={SETTINGS_ACCOUNT} />;
  }

  return (
    <SettingsWrapper pageTitle={TITLES[SettingsPage.DEVELOPER]}>
      <Vertical gap={2}>
        <ApiKeysManagement />
        <OAuthApplicationsManagement />
      </Vertical>
    </SettingsWrapper>
  );
};

export default Developer;
